// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27YKP","image":"Header_image__3qWQQ","name":"Header_name__2E245","info":"Header_info__evMyO","infoRow":"Header_infoRow__2oHsx"};